export const clasificationParties = [
  {
    codigo: 'public',
    etiqueta: 'Público',
  },
  {
    codigo: 'private',
    etiqueta: 'Privado',
  },
];
